import { Routes, Route, Navigate } from "react-router-dom";
import Navigation from "../../../components/Navigation/Navigation.js";
import MaleDistance145 from "./Male/Distance145/Distance145.js";
import MaleDistance90 from "./Male/Distance90/Distance90.js";
import MaleDistance70 from "./Male/Distance70/Distance70.js";
import MaleDistance30 from "./Male/Distance30/Distance30.js";
import FemaleDistance145 from "./Female/Distance145/Distance145.js";
import FemaleDistance90 from "./Female/Distance90/Distance90.js";
import FemaleDistance70 from "./Female/Distance70/Distance70.js";
import FemaleDistance30 from "./Female/Distance30/Distance30.js";


const IndividualRound16 = () => {
  const tabs = [
    { path: "m-distance145", label: "M_145M(Kungdo)" },
    { path: "m-distance90", label: "M_90M(TarscaShild)" },
    { path: "m-distance70", label: "M_70M(Puta)" },
    { path: "m-distance30", label: "M_30M(Zamby)" },
    { path: "f-distance145", label: "F_145M(Kungdo)" },
    { path: "f-distance90", label: "F_90M(TarscaShild)" },
    { path: "f-distance70", label: "F_70M(Puta)" },
    { path: "f-distance30", label: "F_30M(Zamby)" },
  ];

  return (
    <>
      <Navigation
        tabs={tabs}
        basePath="/game-summary/individual_round16"
        variant="tab"
      />

      <Routes>
        <Route path="/" element={<Navigate to="m-distance145" replace />} />
        <Route path="m-distance145/" element={<MaleDistance145 />} />
        <Route path="m-distance90/" element={<MaleDistance90 />} />
        <Route path="m-distance70/" element={<MaleDistance70 />} />
        <Route path="m-distance30/" element={<MaleDistance30 />} />
        <Route path="f-distance145/" element={<FemaleDistance145 />} />
        <Route path="f-distance90/" element={<FemaleDistance90 />} />
        <Route path="f-distance70/" element={<FemaleDistance70 />} />
        <Route path="f-distance30/" element={<FemaleDistance30 />} />
      </Routes>
    </>
  );
};
export default IndividualRound16;
